import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

let appVersion: string | null | undefined;

export const getAppVersion = async () => {
  if (appVersion === undefined) {
    try {
      appVersion = Capacitor.isNativePlatform() ? (await App.getInfo()).version : null;
    } catch {
      appVersion = null;
    }
  }
  return appVersion;
};
